import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Mountain, Info, Download } from "lucide-react";
import { HERO, ObbligoCheck, CatNatInfoSections } from "@/components/CatNatInfo";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VOLANTINO_URL = `${BACKEND_URL}/api/public/catnat/volantino`;
const RICHIESTA_LINK = "/quota/catnat";

export default function CatNatLanding() {
  return (
    <div className="mx-auto max-w-3xl space-y-6" data-testid="catnat-landing">
      {/* HERO */}
      <div className="overflow-hidden rounded-2xl border border-forest/15 bg-forest p-8 text-white md:p-10">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white/90">
          <Info className="h-3.5 w-3.5" /> Contenuto informativo per gli intermediari
        </div>
        <div className="flex items-start gap-4">
          <span className="hidden h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/10 sm:flex">
            <Mountain className="h-7 w-7" strokeWidth={1.75} />
          </span>
          <div>
            <h1 className="font-heading text-2xl font-semibold leading-tight md:text-4xl">{HERO.title}</h1>
            <p className="mt-3 max-w-2xl text-sm text-white/85 md:text-base">{HERO.subtitle}</p>
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <Button asChild size="lg" data-testid="catnat-cta-hero"
                className="gap-2 bg-white text-forest hover:bg-white/90">
                <Link to={RICHIESTA_LINK}>Richiedi la proposta <ArrowRight className="h-4 w-4" /></Link>
              </Button>
              <a href={VOLANTINO_URL} target="_blank" rel="noopener noreferrer"
                data-testid="catnat-volantino-hero"
                className="inline-flex items-center gap-2 text-sm font-medium text-white/85 underline-offset-4 hover:text-white hover:underline">
                <Download className="h-4 w-4" /> Scarica il volantino informativo (PDF)
              </a>
            </div>
            <div className="mt-4 rounded-xl bg-white/10 p-3 text-xs text-white/80">
              <span className="font-semibold text-white">Landing pubblica:</span> condividi con i clienti il link{" "}
              <span className="rounded bg-white/15 px-1.5 py-0.5 font-mono">{BACKEND_URL}/catnat</span> — accessibile senza login.
            </div>
          </div>
        </div>
      </div>

      <ObbligoCheck
        renderCta={(obbligato) => (
          <Button asChild data-testid="check-cta" className="gap-2 bg-forest text-white hover:bg-forest/90">
            <Link to={obbligato ? `${RICHIESTA_LINK}?from=check` : RICHIESTA_LINK}>
              {obbligato ? "Richiedi la proposta" : "Richiedi una valutazione"} <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        )}
      />

      <CatNatInfoSections />

      {/* CTA finale */}
      <div data-testid="catnat-section-7" className="rounded-2xl border border-forest/20 bg-sage/40 p-8 text-center md:p-10">
        <h2 className="font-heading text-xl font-semibold text-forest md:text-2xl">Richiesta di proposta</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm text-forest/80">
          Per richiedere una proposta personalizzata, utilizza il preventivatore CAT NAT già presente nel Portale Partner.
        </p>
        <Button asChild size="lg" data-testid="catnat-cta-footer" className="mt-6 gap-2 bg-forest text-white hover:bg-forest/90">
          <Link to={RICHIESTA_LINK}>Richiedi la proposta <ArrowRight className="h-4 w-4" /></Link>
        </Button>
        <div className="mt-4">
          <a href={VOLANTINO_URL} target="_blank" rel="noopener noreferrer"
            data-testid="catnat-volantino-footer"
            className="inline-flex items-center gap-2 text-sm font-medium text-forest/80 underline-offset-4 hover:text-forest hover:underline">
            <Download className="h-4 w-4" /> Scarica il volantino in PDF
          </a>
        </div>
      </div>

      <p className="pb-2 text-center text-xs text-muted-foreground">
        Contenuto informativo · verificare sempre le Condizioni di Assicurazione e la normativa vigente.
      </p>
    </div>
  );
}
